export default __webpack_public_path__ + "static/living-305ae742e48939e08e198ff622806e53.jpg";